import { render, staticRenderFns } from "./SanatoriumSelect.vue?vue&type=template&id=217ba726&"
import script from "./SanatoriumSelect.vue?vue&type=script&lang=js&"
export * from "./SanatoriumSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports